import { Controller } from "@hotwired/stimulus"

// A native <details> menu: opens with focus on the first row, arrows move
// (wrapping), Escape closes and returns focus, an outside click closes.
// Link rows need no routing here (Enter, middle-click and the keyboard all
// work); an action-button row calls menu#close before its own action.
export default class extends Controller {
  static targets = ["item"]

  connect() {
    this.outside = (e) => { if (!this.element.contains(e.target)) this.element.open = false }
    document.addEventListener("click", this.outside)
  }

  disconnect() { document.removeEventListener("click", this.outside) }

  // Focus left the menu (Tab, or a click elsewhere): close it.
  left(e) {
    if (!this.element.contains(e.relatedTarget)) this.element.open = false
  }

  // A row that is a button (an action, not a link) closes the menu as it
  // runs: <details> would otherwise stay open behind what the row opened.
  close() { this.element.open = false }

  opened() {
    if (this.element.open && this.hasItemTarget) this.itemTargets[0].focus()
  }

  keydown(e) {
    if (e.key === "Escape") {
      this.element.open = false
      this.element.querySelector("summary").focus()
      return
    }
    if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return
    e.preventDefault()
    if (!this.element.open) { this.element.open = true; return }
    const items = this.itemTargets
    const at = items.indexOf(document.activeElement)
    const next = e.key === "ArrowDown" ? (at + 1) % items.length : (at - 1 + items.length) % items.length
    items[next].focus()
  }
}
